import React from "react"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import { useTranslation } from "react-i18next"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react"
import { AdditionalSettingIcon } from "../../Global/atoms/Icons/AdditionalSettingIcon"
import PersonalizeIcon from "../../Global/atoms/Icons/PersonalizeIcon"
import EmailIcon from "../../Global/atoms/Icons/EmailIcon"

interface Props {}

const SettingsNavigation = observer(({}: Props) => {
	const { isMobile } = useScreenType()
	const { t } = useTranslation()
	const formStore = useFormStore()
	const store = useStore()
	const activeAdminSettingsSection = store.adminSettingsSection
	const activeAdminSettingsSectionColor = formStore.settingsData.personalize.colorButton

	return (
		<HyperDiv direction="row" style={{ position: "sticky", top: "0", zIndex: 5 }}>
			<HyperDiv
				flex={1}
				padding="10px"
				centeredX
				className="pointer font-weight-bold"
				style={{
					background:
						activeAdminSettingsSection == "email" ? "var(--white)" : "var(--light-light-gray)",
					color: activeAdminSettingsSection == "email" ? activeAdminSettingsSectionColor : "",
				}}
				onClick={() => store.setAdminSettingsSection("email")}
			>
				{isMobile && (
					<EmailIcon
						strokeColor={
							activeAdminSettingsSection == "email" ? activeAdminSettingsSectionColor : undefined
						}
					/>
				)}
				{!isMobile && <> {t("forms.header.email")} </>}
			</HyperDiv>
			<HyperDiv
				flex={2}
				centeredX
				padding="10px"
				className="pointer font-weight-bold"
				style={{
					background:
						activeAdminSettingsSection == "personalize"
							? "var(--white)"
							: "var(--light-light-gray)",
					color: activeAdminSettingsSection == "personalize" ? activeAdminSettingsSectionColor : "",
				}}
				onClick={() => store.setAdminSettingsSection("personalize")}
			>
				{isMobile && (
					<PersonalizeIcon
						strokeColor={
							activeAdminSettingsSection == "personalize"
								? activeAdminSettingsSectionColor
								: undefined
						}
					/>
				)}
				{!isMobile && <> {t("forms.header.personalize")} </>}
			</HyperDiv>
			<HyperDiv
				flex={1}
				centeredX
				padding="10px"
				className="pointer font-weight-bold"
				style={{
					background:
						activeAdminSettingsSection == "additional" ? "var(--white)" : "var(--light-light-gray)",
					color: activeAdminSettingsSection == "additional" ? activeAdminSettingsSectionColor : "",
				}}
				onClick={() => store.setAdminSettingsSection("additional")}
			>
				{isMobile && (
					<AdditionalSettingIcon
						strokeColor={
							activeAdminSettingsSection == "additional"
								? activeAdminSettingsSectionColor
								: undefined
						}
					/>
				)}
				{!isMobile && <> {t("forms.header.additional")} </>}
			</HyperDiv>
		</HyperDiv>
	)
})

export default SettingsNavigation
